/**
 * Shared login entry. Used by both the control and treatment branch
 * of `routes/login.tsx`'s `dynamicWithExperiment` wrapper since the
 * underlying `<SignPage isLogin />` tree has no SSR-specific data
 * prefetch — the dual-mode split is implemented via
 * `handle.ssrShellExperiment` (controls whether the route bypasses
 * `<RootRuntime>` for SSR), not by swapping the rendered component.
 */
import { Component as SignPage } from 'src/pages/SignPage'

export default function LoginEntry() {
  return <SignPage isLogin />
}
